module.exports = __webpack_public_path__ + "/login_ui/img/fm-9f8fd0b5225424f405a523cf033e5297.svg";